/**
 * Synchronously-readable cache of the most recent Firebase ID token.
 *
 * Kept in its own tiny module (no Firebase SDK imports) so that the GraphQL
 * client can read the bearer token without statically importing the Firebase
 * SDK. The GraphQLCore `loadDefaultsCallback` runs synchronously, so it reads
 * this cache (refreshed by FirebaseAuthProvider via onAuthStateChanged and the
 * 50-minute refresh loop) rather than awaiting `getIdToken()` per request.
 */

let cachedToken = null;

export const getCachedToken = () => cachedToken;

export const setCachedToken = (token) => {
  cachedToken = token || null;
};
